import { render, staticRenderFns } from "./drugModel_targetGene.vue?vue&type=template&id=a8d0f8f6&"
import script from "./drugModel_targetGene.vue?vue&type=script&lang=js&"
export * from "./drugModel_targetGene.vue?vue&type=script&lang=js&"
import style0 from "./drugModel_targetGene.vue?vue&type=style&index=0&id=a8d0f8f6&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports